import type { SchemaEntity, JsonLdDocument } from "./types";

export function buildJsonLdDocument(entities: SchemaEntity[]): JsonLdDocument {
  return {
    "@context": "https://schema.org/",
    "@graph": entities,
  };
}
